// Contenido legal — español. Espejo cláusula por cláusula de fr.js y en.js.
import termsEs from "./termsEs";

export default {
  terms: termsEs,
  privacy: {
    lastUpdatedLabel: "Última actualización",
    sections: [
      {
        id: "data-collected",
        heading: "1. Datos que recopilamos",
        paragraphs: [
          "Recopilamos información de cuenta (nombre, email), los datos de tu práctica que ingresas, y datos técnicos (logs, cookies de sesión) necesarios para operar el servicio.",
        ],
      },
      {
        id: "use",
        heading: "2. Uso",
        paragraphs: [
          "Tus datos se usan para prestar y mejorar el servicio, procesar pagos y garantizar la seguridad. No vendemos tus datos.",
        ],
      },
      {
        id: "clients-data",
        heading: "3. Datos de tus clientes",
        paragraphs: [
          "Eres responsable del tratamiento de los datos de tus propios clientes. Solunary actúa como encargado del tratamiento y aplica medidas de seguridad razonables.",
        ],
      },
      {
        id: "sharing",
        heading: "4. Compartición",
        paragraphs: [
          "Compartimos datos solo con encargados necesarios (hosting, pagos vía Stripe, emails vía Resend) y cuando la ley lo exige.",
        ],
      },
      {
        id: "retention-rights",
        heading: "5. Conservación y derechos",
        paragraphs: [
          "Puedes acceder, corregir o eliminar tus datos desde ajustes o contactándonos. Los datos se conservan el tiempo necesario para el servicio.",
        ],
      },
      {
        id: "security",
        heading: "6. Seguridad",
        paragraphs: [
          "Aplicamos cifrado en tránsito y controles de acceso. Ningún sistema es infalible; reporta cualquier incidente.",
        ],
      },
      {
        id: "cookies",
        heading: "7. Cookies",
        paragraphs: [
          "Usamos cookies de sesión esenciales para la autenticación. Sin cookies publicitarias de terceros.",
        ],
      },
      {
        id: "contact",
        heading: "8. Contacto",
        paragraphs: [
          "Preguntas: hey@solunary.health.",
        ],
      },
    ],
  },
};
